import React, { useEffect } from 'react';
import { 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Box 
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCurrentUser } from '../../slices/userSlice';

function Account() {
  const dispatch = useDispatch();

  // Auth info from Amplify (or equivalent).
  const authUser = useSelector((state) => state.auth.user);

  // Full user info from the /me API call.
  // Note: The userSlice stores fields like id, email, etc., at the top level.
  const user = useSelector((state) => state.user);

  // Fetch the full current user info when the component mounts.
  useEffect(() => {
    if (authUser) {
      dispatch(fetchCurrentUser())
        .unwrap()
        .catch((error) => {
          console.error('Error fetching current user:', error);
        });
    }
  }, [dispatch, authUser]);

  // If the user data is still loading, show a loading state.
  if (user.status === 'loading') {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Typography>Loading user data...</Typography>
      </Container>
    );
  }

  // If there was an error while fetching the user data, display it.
  if (user.status === 'failed' && user.error) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Typography color="error">Error: {user.error}</Typography>
      </Container>
    );
  }

  // Navigate to Stripe billing portal in a new tab
  const handleManagePlan = () => {
    window.open('https://billing.stripe.com/p/login/test_6oE3dzgmyaFYa7C7ss', '_blank');
  };

  // Render the Account information.
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Typography variant="h4" gutterBottom>
        Account Settings
      </Typography>

      <Box component="form" noValidate autoComplete="off" sx={{ mt: 4 }}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          // Prefer the fetched user.email; fallback to authUser.email if needed.
          value={user.email || authUser?.email || ''}
          disabled
        />

        {/* <TextField
          label="Portfolio ID"
          fullWidth
          margin="normal"
          value={user.portfolio_id || ''}
          disabled
        />

        <TextField
          label="Subscription Status"
          fullWidth
          margin="normal"
          value={user.subscription_status || ''}
          disabled
        />

        <TextField
          label="Stripe Customer ID"
          fullWidth
          margin="normal"
          value={user.stripe_customer_id || ''}
          disabled
        />

        <TextField
          label="Next Billing Date"
          fullWidth
          margin="normal"
          value={
            user.nextBillingDate
              ? new Date(user.nextBillingDate).toLocaleDateString()
              : 'N/A'
          }
          disabled
        /> */}

        <TextField
          label="Subscription Status"
          fullWidth
          margin="normal"
          value={user.is_active ? 'Yes' : 'No'}
          disabled
        />

        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" color="primary" onClick={handleManagePlan}>
            Manage Subscription
          </Button>
          <Button 
            variant="contained" 
            sx={{
              backgroundColor: '#FFD700', // Yellow color
              color: '#000000', // Black text
              '&:hover': {
                backgroundColor: '#FFE44D', // Slightly lighter yellow on hover
              }
            }}
          >
            Donate to Autistic People
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default Account;
